import { BaseTypeLiterals } from "../base/base-type";

// TODO: Deprecated.
export type MimeTypeGroup = "image" | "pdf" | "*";

export const supportedExtensions = [
  "png",
  "jpeg",
  "jpg",
  "gif",
  "heif",
  "heic",
  "xlsx",
  "docx",
  "pptx",
  "pdf",
  "zip",
] as const;

export const mimeTypeList = [
  "image/png",
  "image/jpeg",
  "image/gif",
  "image/heif",
  "image/heic",
  "application/pdf",
  // "application/json",
  // "application/msword",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  // "application/vnd.ms-excel",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  // "application/vnd.ms-powerpoint",
  "application/vnd.openxmlformats-officedocument.presentationml.presentation",
  "application/zip",
  "application/x-zip-compressed",
] as const;

export type SupportedExtension = (typeof supportedExtensions)[number];
export type MimeType = (typeof mimeTypeList)[number];

export const ExtensionMimeType: BaseTypeLiterals<SupportedExtension, MimeType> =
  {
    png: "image/png",
    jpeg: "image/jpeg",
    jpg: "image/jpeg",
    gif: "image/gif",
    heif: "image/heif",
    heic: "image/heic",
    xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    docx: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    pptx: "application/vnd.openxmlformats-officedocument.presentationml.presentation",
    pdf: "application/pdf",
    zip: "application/zip",
  };

export const MimeTypeToExtension: BaseTypeLiterals<
  MimeType,
  SupportedExtension[]
> = {
  "image/png": ["png"],
  "image/jpeg": ["jpg", "jpeg"],
  "image/gif": ["gif"],
  "image/heif": ["heif"],
  "image/heic": ["heic"],
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": ["xlsx"],
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document": [
    "docx",
  ],
  "application/vnd.openxmlformats-officedocument.presentationml.presentation": [
    "pptx",
  ],
  "application/pdf": ["pdf"],
  "application/zip": ["zip"],
  "application/x-zip-compressed": ["zip"],
};

export function filenameToExtension(filename: string) {
  const a = filename.split(".");
  if (a.length === 1 || (a[0] === "" && a.length === 2)) {
    return "";
  }
  return a.pop() || "";
}
